<h2 mat-dialog-title>
  Updated Legal Terms
</h2>

<mat-dialog-content>

  <p>
    Please review and accept the updated legal documents to continue using our services. You can view the full documents by clicking the links below.
  </p>

  <form [formGroup]="form">

    @if (data.requires_terms_of_service_acceptance) {

      <mat-checkbox formControlName="accept_terms_of_service">

        I agree to the

        <a
          routerLink="/pages/terms-of-service"
          target="_blank"
          (click)="$event.stopPropagation()"
        >
          Terms of Service
        </a>

      </mat-checkbox>

    }


    @if (data.requires_privacy_policy_acceptance) {

      <mat-checkbox
        formControlName="accept_privacy_policy"
        class="mt-10"
      >

        I agree to the

        <a
          routerLink="/pages/privacy-policy"
          target="_blank"
          (click)="$event.stopPropagation()"
        >
          Privacy Policy
        </a>

      </mat-checkbox>

    }

  </form>

</mat-dialog-content>


<mat-dialog-actions align="end">

  <button
    mat-button
    type="button"
    class="danger-button"
    [disabled]="loading()"
    (click)="logout()"
  >
    Decline
  </button>


  <button
    mat-flat-button
    type="button"
    class="lightgreen-button"
    [disabled]="form.invalid || loading()"
    (click)="acceptLegal()"
  >

    @if (!loading()) {

      Accept

    } @else {

      <mat-spinner
        diameter="20"
        strokeWidth="3"
      ></mat-spinner>

    }

  </button>

</mat-dialog-actions>